import Vue from 'vue'
import Vuex from 'vuex'

import global from './modules/_global'; //module representing global elements of the calculator
import selections from './modules/selections'; //module representing user selections in the calculator
import curriculumStore from './modules/curriculum-store';
import fee from './modules/fee-store';

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        global,
        selections,
        curriculumStore,
        fee,
    }
});
